module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABBklEQVQ4T53SPUsDMRzH8W9aG1dFBAdBV0EXcVBooWCHvgCHTh44F50s3ObDpNO1Y8cDdyvo4uCb8A0IbgV72OJTLolExVJb7Z3/Mckn+Sf5CQ6sJGtOgW1gmr+rA4ToTE1wrANgbwz4OV130O0ylQpaIgdtKvS1ODFcmjE0y4rC2eQHTQRXZg3BpmLnSnL3KIZhs/xG7SZH9Po56WptznBSVHiXkvtuf3zgxNKixl+PqbQk7WdBaUHjb8RULiTtpz4a2Wp+3nCYV4S3Wbxlzda55OFlEP16R9dedTWmep2jp4ZR4scZ9V3/CwB0BEeqjsjspgqBpSG+Q27xEGOiZ4nAhJiJ/XdXWWMNkGw90QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/checkedImg.png
// module id = SSEu
// module chunks = 2